<div mat-dialog-title>{{title}}</div>
  <mat-dialog-content>
    <content-widget [tag]="tag"></content-widget>
  </mat-dialog-content>
<mat-dialog-actions>
  <button mat-button type="button" color="primary" [mat-dialog-close]="true">Done</button>
</mat-dialog-actions>
